import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from '@patternfly/react-core';
import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState, } from 'react';
import { AutoField } from './fields/AutoField';
import { NoFieldFound } from './Form/NoFieldFound';
import './KaotoForm.scss';
import { FormComponentFactoryProvider } from './providers/FormComponentFactoryProvider';
import { ModelContextProvider } from './providers/ModelProvider';
import { SchemaDefinitionsProvider } from './providers/SchemaDefinitionsProvider';
import { SchemaProvider } from './providers/SchemaProvider';
import { isDefined, ROOT_PATH, setValue } from './utils';
import { errorsMapper } from './validation/errors-mapper';
import { getValidator } from './validation/get-validator';
export const KaotoForm = forwardRef(({ 'data-testid': dataTestId, schema, model, omitFields = [], disabled, onChange, onChangeProp, customFieldsFactory, }, forwardRef) => {
    if (!isDefined(schema)) {
        throw new Error('[KaotoForm]: Schema is required');
    }
    const [formModel, setFormModel] = useState(model);
    const [validationErrors, setValidationErrors] = useState({});
    const onChangeRef = useRef(onChange);
    const isFirstRender = useRef(true);
    useEffect(() => {
        onChangeRef.current = onChange;
    }, [onChange]);
    useEffect(() => {
        var _a;
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, formModel);
    }, [formModel]);
    const onPropertyChange = useCallback((propName, value) => {
        onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(propName, value);
        setFormModel((prevModel) => {
            if (typeof prevModel !== 'object') {
                return value;
            }
            const newModel = Object.assign({}, prevModel);
            setValue(newModel, propName, value);
            return newModel;
        });
    }, [onChangeProp]);
    const validator = useMemo(() => getValidator(schema), [schema]);
    const schemaValidator = useCallback((model) => {
        validator === null || validator === void 0 ? void 0 : validator(model);
        const mappedErrors = errorsMapper(validator === null || validator === void 0 ? void 0 : validator.errors);
        setValidationErrors(mappedErrors);
        return Object.keys(mappedErrors).length > 0 ? mappedErrors : null;
    }, [validator]);
    useImperativeHandle(forwardRef, () => ({ validate: () => schemaValidator(formModel) }), [
        formModel,
        schemaValidator,
    ]);
    const onSubmit = useCallback((event) => {
        event.preventDefault();
    }, []);
    return (_jsx(FormComponentFactoryProvider, { customFieldsFactory: customFieldsFactory, children: _jsx(SchemaDefinitionsProvider, { schema: schema, omitFields: omitFields, children: _jsx(SchemaProvider, { schema: schema, children: _jsxs(ModelContextProvider, { model: formModel, errors: validationErrors, onPropertyChange: onPropertyChange, disabled: disabled, children: [_jsx(Form, { onSubmit: onSubmit, className: "kaoto-form kaoto-form__label", "data-testid": dataTestId, children: _jsx(AutoField, { propName: ROOT_PATH }) }), _jsx(NoFieldFound, { className: "kaoto-form kaoto-form__empty" })] }) }) }) }));
});
//# sourceMappingURL=KaotoForm.js.map